import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';


@Injectable()
export class VerificarFormRouterGuard implements CanDeactivate<''> {


    canDeactivate(
        component: '',
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return false;
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/guards/verificar-form-router.guard.ts